import * as environment from '@app/environment'

export const DEFAULT_TITLE = environment.siteName
export const DEFAULT_DESCRIPTION = ''
